<template>
  <v-container fluid>
    <bar-chart
      ref="barChart"
      :datasets="datasets"
      :labels="labels"
      :options="options"
    />
  </v-container>
</template>
<script>
  import barChart from '@/views/dashboard/component/BarChart'
  // import searchDelay from '@/extra-functions/searchDelay.extra'
  import { mapState } from 'vuex'

  // const renderDelay = searchDelay()

  export default {
    name: 'StoreComparisonChart',
    components: {
      barChart,
    },
    props: {
      data: Array,
    },
    data () {
      return {
        datasets: [],
        labels: ['Sales', 'Loan Returns', 'Loans Lent', 'Lost', 'Expenses'],
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      }
    },
    mounted () {
      this.initChart()
    },
    computed: {
      ...mapState({
        stores: state => state.branchLocation.list,
      }),
    },
    watch: {
      stores (list) {
        this.render()
      },
      data (data) {
        const datasets = this.datasets
        this.datasets = datasets.map((e, i) => {
          e.data = data[i]
          return e
        })
        this.render()
      },
    },
    methods: {
      render () {
        this.$refs.barChart.render()
      },
      initChart () {
        const bkgOpacity = 0.5
        // const brdOpacity = 0.9
        const backgroundColors = [
          `rgba(076, 175, 080, ${bkgOpacity})`,
          `rgba(255, 152, 000, ${bkgOpacity})`,
          `rgba(156, 050, 040, ${bkgOpacity})`,
          `rgba(224, 086, 253, ${bkgOpacity})`,
          `rgba(072, 052, 212, ${bkgOpacity})`,
          `rgba(233, 030, 099, ${bkgOpacity})`,
          `rgba(000, 202, 227, ${bkgOpacity})`,
          `rgba(096, 125, 139, ${bkgOpacity})`,
        ]
        this.datasets = this.stores.map((el, i) => {
          return {
            label: el.name,
            backgroundColor: backgroundColors[i],
            data: [0, 0, 0, 0],
          }
        })

        this.render()
      },
    },
  }
</script>
